import React from 'react';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';

import MobileTabTable from 'components/ModularBlocks/TabTable/components/MobileTabTable';
import TabTableBody from 'components/ModularBlocks/TabTable/components/TabTableBody';
import TabTableHeader from 'components/ModularBlocks/TabTable/components/TabTableHeader';

import { TabTableTabI } from 'interfaces/content-stack/modular-blocks/tabTable';

import comparisonTableShape from 'shapes/components/comparisonTableShape';

import { buildBasicRows } from 'utils/functions';

const COMPARISON_ROW = 'Comparison Row';

const TableContainer = styled.div`
  overflow-x: scroll;
`;

const StyledTable = styled.div<{ $mobileStyle: string }>`
  font-weight: 400;
  margin-bottom: 1em;
  gap: 0rem;
  flex-direction: column;
  display: flex;

  ${ifProp(
    { $mobileStyle: 'Comparison Row' },
    css`
      display: none;

      @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        display: table;
      }
    `
  )}

  @media screen and (max-width: ${(props) => props.theme.breakpoints.md}) {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  @media screen and (max-width: ${(props) => props.theme.breakpoints.xs}) {
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
    padding-right: 0;
  }
`;

Table.propTypes = {
  className: PropTypes.string,
  data: comparisonTableShape,
};

interface TabTableTableProps {
  data: TabTableTabI;
}

function Table({ data }: TabTableTableProps) {
  if (!data) {
    return null;
  }

  const { mobileTableStyle, tableHeaders, tableColumns } = data;
  const rows = buildBasicRows(tableColumns);

  return (
    <TableContainer>
      <StyledTable $mobileStyle={mobileTableStyle}>
        {tableHeaders.length > 0 && <TabTableHeader headers={tableHeaders} mobileStyle={mobileTableStyle} />}
        {tableColumns.length > 0 && <TabTableBody columns={tableColumns} mobileStyle={mobileTableStyle} rows={rows} />}
      </StyledTable>
      {mobileTableStyle === COMPARISON_ROW && <MobileTabTable headers={tableHeaders} columns={tableColumns} />}
    </TableContainer>
  );
}

export default React.memo(Table);
